import {
  START_FETCH_HOME_PAGE_DATA,
  SUCCESS_FETCH_HOME_PAGE_DATA,
  ERROR_FETCH_HOME_PAGE_DATA,
} from "./../actions/homePageActionsTypes";

const initialState = {
  isLoading: false,
  homePageData: [],
  errorFetchingHomePageData: "",
};

const HomeReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_FETCH_HOME_PAGE_DATA:
      return {
        ...state,
        isLoading: true,
      };
    case SUCCESS_FETCH_HOME_PAGE_DATA:
      return {
        ...state,
        isLoading: false,
        homePageData: action.homePageData,
        errorFetchingHomePageData: "",
      };
    case ERROR_FETCH_HOME_PAGE_DATA:
      return {
        ...state,
        isLoading: false,
        errorFetchingHomePageData: action.error,
      };
    default:
      return state;
  }
};
export default HomeReducer;
